import EmitterManager from './EmitterManager';
import { SCROLL, SCROLL_UPDATE, SCROLL_TOGGLE } from '../core/Events';
import { NO_SCROLL } from 'core/Classes';

export const scrollingElement = document.scrollingElement || document.documentElement;

const defaults = {
	autoEnable: true,
	preventTouchMove: false
};

class ScrollManager {
	constructor(options) {
		this._userScrollEnabled = true;

		this.options = Object.assign({}, defaults, options);
		this.bind();

		this.isDisabled = document.documentElement.classList.contains('no-scroll');
		this.scrollTop = scrollingElement.scrollTop;

		if (this.options.autoEnable) {
			this.enable();
		}
	}

	bind() {
		this.handleScroll = this.handleScroll.bind(this);
		this.emitScrollEvent = this.emitScrollEvent.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}

	enable() {
		this.events(true);
	}

	disable() {
		this.events(false);
	}

	events(listen = false) {
		let method = null;

		method = listen === false ? 'removeEventListener' : 'addEventListener';
		window[method](SCROLL, this.handleScroll);

		method = listen === false ? 'removeListener' : 'on';
		EmitterManager[method](SCROLL_UPDATE, this.handleScroll);
		EmitterManager[method](SCROLL_TOGGLE, this.handleToggle);
	}

	handleToggle(disable) {
		const hasClass = document.documentElement.classList.contains(NO_SCROLL);

		if (disable && !hasClass) {
			document.body.style.top = `${-document.scrollingElement.scrollTop}px`;
			document.documentElement.classList.add(NO_SCROLL);
			this.isDisabled = true;
		} else if (!disable && hasClass) {
			const top = Math.abs(parseInt(document.body.style.top));
			document.body.style.removeProperty('top');
			document.documentElement.classList.remove(NO_SCROLL);
			document.scrollingElement.scrollTo(0, top);
			this.isDisabled = false;
		}
	}

	handleScroll() {
		this.scrollTop = scrollingElement.scrollTop;

		if (this.scrollTicking !== true) {
			requestAnimationFrame(this.emitScrollEvent);
		}

		this.scrollTicking = true;
	}

	emitScrollEvent() {
		EmitterManager.emit(SCROLL, this.scrollTop);

		this.scrollTicking = false;
	}
}

export default new ScrollManager();
